import { InfiniteData, UseMutationOptions } from "@tanstack/react-query";
import {
  useAuthInfiniteQuery,
  useAuthMutation,
  UseInfiniteQueryExtendedOptions,
} from "@rentablo/api";
import {
  PageableTransactionV2List,
  TransactionsApiListAndSearchAllTransactionV2Request,
  CACHE_KEYS,
  listAndSearchAllTransactionV2,
} from "@rentablo/api/apiv1";
import { downloadTransactions } from "@api/v1";

export const useInfiniteTransactionsV2 = (
  params?: TransactionsApiListAndSearchAllTransactionV2Request,
  options?: UseInfiniteQueryExtendedOptions<
    PageableTransactionV2List,
    AxiosApiError,
    InfiniteData<PageableTransactionV2List>
  >
) => {
  return useAuthInfiniteQuery(
    [CACHE_KEYS.LIST_AND_SEARCH_ALL_TRANSACTION_V2, params],
    ({ token, pageParam }) =>
      listAndSearchAllTransactionV2(token, {
        ...params,
        page: pageParam || 1,
      }),
    options
  );
};

export const useDownloadTransactions = (
  params: TransactionsApiListAndSearchAllTransactionV2Request,
  options?: UseMutationOptions<Blob, AxiosApiError, unknown>
) => useAuthMutation((token) => downloadTransactions(token, params), options);
